module.exports = __webpack_public_path__ + "static/media/bullet-list-69_1.32f62052.svg";